import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardActions,
  Button,
  Typography,
  Grid,
  Chip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Background from "../../components/Background";
import DashboardFooter from "../../components/Footer";

// POC: hardcoded course list. Only id and display info needed —
// scormVersion and entryPoint are read from imsmanifest.xml at runtime.
const courses = [
  {
    id: "test",
    title: "Sample SCORM Course",
    description: "A test course for validating the SCORM player integration.",
  },
];

function getProgress(courseId) {
  try {
    const raw = localStorage.getItem(`scorm-progress-${courseId}`);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function getStatusLabel(progress) {
  if (!progress) return "Not Started";
  const status =
    progress["cmi.core.lesson_status"] ||
    progress["cmi.completion_status"] ||
    "not attempted";
  switch (status) {
    case "completed":
    case "passed":
      return "Completed";
    case "incomplete":
      return "In Progress";
    case "failed":
      return "Failed";
    default:
      return "Not Started";
  }
}

function getStatusColor(label) {
  switch (label) {
    case "Completed":
      return "success";
    case "In Progress":
      return "warning";
    case "Failed":
      return "error";
    default:
      return "default";
  }
}

export default function ScormCourseList() {
  const navigate = useNavigate();

  return (
    <Background>
      <Box sx={{ maxWidth: 1200, mx: "auto", py: 4, px: { xs: 2, md: 4 } }}>
        <Typography
          variant="h5"
          sx={{ fontWeight: 600, color: "#2A4876", mb: 3 }}
        >
          Training Courses
        </Typography>
        <Grid container spacing={3}>
          {courses.map((course) => {
            const progress = getProgress(course.id);
            const statusLabel = getStatusLabel(progress);
            const hasStarted = statusLabel !== "Not Started";
            return (
              <Grid item xs={12} sm={6} md={4} key={course.id}>
                <Card
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "12px",
                    boxShadow: "0px 2px 8px rgba(0,0,0,0.08)",
                    "&:hover": { boxShadow: "0px 4px 16px rgba(0,0,0,0.12)" },
                  }}
                >
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 1,
                      }}
                    >
                      <Typography
                        variant="h6"
                        sx={{ fontWeight: 600, color: "#2A4876" }}
                      >
                        {course.title}
                      </Typography>
                      <Chip
                        label={statusLabel}
                        color={getStatusColor(statusLabel)}
                        size="small"
                      />
                    </Box>
                    <Typography variant="body2" sx={{ color: "#666", mb: 1 }}>
                      {course.description}
                    </Typography>
                  </CardContent>
                  <CardActions sx={{ px: 2, pb: 2 }}>
                    <Button
                      variant="contained"
                      fullWidth
                      onClick={() => navigate(`/scorm/player/${course.id}`)}
                      sx={{
                        borderRadius: "100px",
                        textTransform: "capitalize",
                        backgroundColor: "#2A4876",
                        "&:hover": { backgroundColor: "#1d3456" },
                      }}
                    >
                      {hasStarted ? "Resume" : "Start"}
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Box>
      <DashboardFooter />
    </Background>
  );
}
